export default {
  ru: {
    // мм
    mmt: 'мм',
    // см
    cmt: 'см',
    // дм
    dmt: 'дм',
    // м
    mtr: 'м',
    // км
    kmt: 'км',
    // дюйм
    inh: 'дюйм',
    // фут
    fot: 'фут',
    // ярд
    yrd: 'ярд',
    // м2
    mtk: 'м2',
    // дм2
    dmk: 'дм2',
    // мл
    mlt: 'мл',
    // см3
    cmq: 'см3',
    // л
    ltr: 'л',
    // дм3
    dmq: 'дм3',
    // м3
    mtq: 'м3',
    // г
    grm: 'г',
    // кг
    kgm: 'кг',
    // т
    tne: 'т',
    // час
    hur: 'час',
    // боб??
    nbb: 'боб',
    // лист
    lef: 'лист',
    // набор
    set: 'набор',
    // пар
    npr: 'пар',
    // рул
    npl: 'рул',
    // упак
    nmp: 'упак',
    // дюжина упак
    dzp: 'дюжина упак',
    // 100 упак
    cnp: '100 упак',
    // шт
    pce: 'шт',
    // 100 шт
    cen: '100 шт',
    // тыс. шт
    mil: 'тыс. шт',
    // ящ
    box: 'ящ',
    // секц
    sct: 'секц',
    // флак
    btl: 'флак',
    // пог.м
    lmt: 'пог.м'
  },
  be: {
    // мм
    mmt: 'мм',
    // см
    cmt: 'см',
    // дм
    dmt: 'дм',
    // м
    mtr: 'м',
    // км
    kmt: 'км',
    // дюйм
    inh: 'дюйм',
    // фут
    fot: 'фут',
    // ярд
    yrd: 'ярд',
    // м2
    mtk: 'м2',
    // дм2
    dmk: 'дм2',
    // мл
    mlt: 'мл',
    // см3
    cmq: 'см3',
    // л
    ltr: 'л',
    // дм3
    dmq: 'дм3',
    // м3
    mtq: 'м3',
    // г
    grm: 'г',
    // кг
    kgm: 'кг',
    // т
    tne: 'т',
    // час
    hur: 'час',
    // боб??
    nbb: 'боб',
    // лист
    lef: 'лист',
    // набор
    set: 'набор',
    // пар
    npr: 'пар',
    // рул
    npl: 'рул',
    // упак
    nmp: 'упак',
    // дюжина упак
    dzp: 'дюжина упак',
    // 100 упак
    cnp: '100 упак',
    // шт
    pce: 'шт',
    // 100 шт
    cen: '100 шт',
    // тыс. шт
    mil: 'тыс. шт',
    // ящ
    box: 'ящ',
    // секц
    sct: 'секц',
    // флак
    btl: 'флак',
    // пог.м
    lmt: 'пог.м'
  },
  kz: {
    // мм
    mmt: 'мм',
    // см
    cmt: 'см',
    // дм
    dmt: 'дм',
    // м
    mtr: 'м',
    // км
    kmt: 'км',
    // дюйм
    inh: 'дюйм',
    // фут
    fot: 'фут',
    // ярд
    yrd: 'ярд',
    // м2
    mtk: 'м2',
    // дм2
    dmk: 'дм2',
    // мл
    mlt: 'мл',
    // см3
    cmq: 'см3',
    // л
    ltr: 'л',
    // дм3
    dmq: 'дм3',
    // м3
    mtq: 'м3',
    // г
    grm: 'г',
    // кг
    kgm: 'кг',
    // т
    tne: 'т',
    // час
    hur: 'час',
    // боб??
    nbb: 'боб',
    // лист
    lef: 'лист',
    // набор
    set: 'набор',
    // пар
    npr: 'пар',
    // рул
    npl: 'рул',
    // упак
    nmp: 'упак',
    // дюжина упак
    dzp: 'дюжина упак',
    // 100 упак
    cnp: '100 упак',
    // шт
    pce: 'шт',
    // 100 шт
    cen: '100 шт',
    // тыс. шт
    mil: 'тыс. шт',
    // ящ
    box: 'ящ',
    // секц
    sct: 'секц',
    // флак
    btl: 'флак',
    // пог.м
    lmt: 'пог.м'
  },
  ua: {
    // мм
    mmt: 'мм',
    // см
    cmt: 'см',
    // дм
    dmt: 'дм',
    // м
    mtr: 'м',
    // км
    kmt: 'км',
    // дюйм
    inh: 'дюйм',
    // фут
    fot: 'фут',
    // ярд
    yrd: 'ярд',
    // м2
    mtk: 'м2',
    // дм2
    dmk: 'дм2',
    // мл
    mlt: 'мл',
    // см3
    cmq: 'см3',
    // л
    ltr: 'л',
    // дм3
    dmq: 'дм3',
    // м3
    mtq: 'м3',
    // г
    grm: 'г',
    // кг
    kgm: 'кг',
    // т
    tne: 'т',
    // час
    hur: 'час',
    // боб??
    nbb: 'боб',
    // лист
    lef: 'лист',
    // набор
    set: 'набор',
    // пар
    npr: 'пар',
    // рул
    npl: 'рул',
    // упак
    nmp: 'упак',
    // дюжина упак
    dzp: 'дюжина упак',
    // 100 упак
    cnp: '100 упак',
    // шт
    pce: 'шт',
    // 100 шт
    cen: '100 шт',
    // тыс. шт
    mil: 'тыс. шт',
    // ящ
    box: 'ящ',
    // секц
    sct: 'секц',
    // флак
    btl: 'флак',
    // пог.м
    lmt: 'пог.м'
  },
  en: {
    // мм
    mmt: 'mmt',
    // см
    cmt: 'cmt',
    // дм
    dmt: 'dmt',
    // м
    mtr: 'mtr',
    // км
    kmt: 'kmt',
    // дюйм
    inh: 'inh',
    // фут
    fot: 'fot',
    // ярд
    yrd: 'yrd',
    // м2
    mtk: 'mtk',
    // дм2
    dmk: 'dmk',
    // мл
    mlt: 'mlt',
    // см3
    cmq: 'cmq',
    // л
    ltr: 'ltr',
    // дм3
    dmq: 'dmq',
    // м3
    mtq: 'mtq',
    // г
    grm: 'grm',
    // кг
    kgm: 'kgm',
    // т
    tne: 'tne',
    // час
    hur: 'hur',
    // боб??
    nbb: 'nbb',
    // лист
    lef: 'lef',
    // набор
    set: 'set',
    // пар
    npr: 'npr',
    // рул
    npl: 'npl',
    // упак
    nmp: 'nmp',
    // дюжина упак
    dzp: 'dzp',
    // 100 упак
    cnp: 'cnp',
    // шт
    pce: 'pce',
    // 100 шт
    cen: 'cen',
    // тыс. шт
    mil: 'mil',
    // ящ
    box: 'box',
    // секц
    sct: 'sct',
    // флак
    btl: 'btl',
    // пог.м
    lmt: 'lmt'
  }
};
